// AUTO-GENERATED by scripts/fetch-ssg-data.mjs — do not edit.
export interface SsgMatch {
    date: string; gameNumber: string; group: string; time: string;
    homeTeam: string; homePK: number; homeScore: string; awayScore: string;
    awayPK: number; awayTeam: string; venue: string;
}
export const ssgUpdatedAt: string = "2026-10-06T12:19:56.113Z";
export const ssgPages: Record<string, SsgMatch[]> = {
    "/mayors-cup/2024/open": [
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 1,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "台中一中白",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 7,
            "awayPK": 0,
            "awayTeam": "足夢 U18B",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 2,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "明道中學",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 3,
            "awayPK": 0,
            "awayTeam": "FOCUS",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 3,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "嶺東中學",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "足夢 U18A",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 4,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "台中一中黑",
            "homePK": 0,
            "homeScore": 2,
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "BEST台中一中",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 5,
            "group": "A",
            "time": "1899-12-30T04:23:18.000Z",
            "homeTeam": "足夢 U18B",
            "homePK": 0,
            "homeScore": 2,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "FOCUS",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 6,
            "group": "A",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "台中一中白",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "明道中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 7,
            "group": "B",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "嶺東中學",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "台中一中黑",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 8,
            "group": "B",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "足夢 U18A",
            "homePK": 0,
            "homeScore": 5,
            "awayScore": 1,
            "awayPK": 0,
            "awayTeam": "BEST台中一中",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 9,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "C1",
            "homePK": 0,
            "homeScore": 10,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "台中一中白",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 10,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "足夢 U18B",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 1,
            "awayPK": 0,
            "awayTeam": "明道中學",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 11,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "BEST台中一中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 3,
            "awayPK": 0,
            "awayTeam": "嶺東中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 12,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "足夢 U18A",
            "homePK": 0,
            "homeScore": 5,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "台中一中黑",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 13,
            "group": "SF",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "FOCUS",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 5,
            "awayPK": 0,
            "awayTeam": "嶺東中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 14,
            "group": "SF",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "足夢 U18B",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "足夢 U18A",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-20T16:00:00.000Z",
            "gameNumber": 15,
            "group": "3rd",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "FOCUS",
            "homePK": 0,
            "homeScore": 3,
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "足夢 U18B",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-20T16:00:00.000Z",
            "gameNumber": 16,
            "group": "F",
            "time": "1899-12-30T03:23:18.000Z",
            "homeTeam": "嶺東中學",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 3,
            "awayPK": 0,
            "awayTeam": "足夢 U18A",
            "venue": "崇倫 A"
        }
    ],
    "/mayors-cup/2024/school": [
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 1,
            "group": "A",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "安和國中",
            "homePK": 0,
            "homeScore": 7,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "衛道中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 2,
            "group": "A",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "爽文國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "崇倫國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 3,
            "group": "B",
            "time": "1899-12-30T03:23:18.000Z",
            "homeTeam": "黎明國中",
            "homePK": 0,
            "homeScore": 3,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "潭秀國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 4,
            "group": "A",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "爽文國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "安和國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 5,
            "group": "A",
            "time": "1899-12-30T07:23:18.000Z",
            "homeTeam": "崇倫國中",
            "homePK": 0,
            "homeScore": 6,
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "衛道中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 6,
            "group": "B",
            "time": "1899-12-30T08:23:18.000Z",
            "homeTeam": "福科國中",
            "homePK": 0,
            "homeScore": 8,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "黎明國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 7,
            "group": "A",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "崇倫國中",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "安和國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 8,
            "group": "A",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "衛道中學",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "爽文國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 9,
            "group": "B",
            "time": "1899-12-30T03:23:18.000Z",
            "homeTeam": "潭秀國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 5,
            "awayPK": 0,
            "awayTeam": "福科國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 10,
            "group": "SF",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "安和國中",
            "homePK": 0,
            "homeScore": 2,
            "awayScore": 5,
            "awayPK": 0,
            "awayTeam": "潭秀國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 11,
            "group": "3rd",
            "time": "1899-12-30T07:23:18.000Z",
            "homeTeam": "崇倫國中",
            "homePK": 0,
            "homeScore": 3,
            "awayScore": 6,
            "awayPK": 0,
            "awayTeam": "福科國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-29T16:00:00.000Z",
            "gameNumber": 12,
            "group": "F",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "安和國中",
            "homePK": 0,
            "homeScore": 5,
            "awayScore": 1,
            "awayPK": 0,
            "awayTeam": "崇倫國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-29T16:00:00.000Z",
            "gameNumber": 13,
            "group": "",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "潭秀國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "福科國中",
            "venue": "崇倫 A"
        }
    ],
    "/mayors-cup/2025/open": [
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 1,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "台中一中白",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 7,
            "awayPK": 0,
            "awayTeam": "足夢 U18B",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 2,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "明道中學",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 3,
            "awayPK": 0,
            "awayTeam": "FOCUS",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 3,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "嶺東中學",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "足夢 U18A",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 4,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "台中一中黑",
            "homePK": 0,
            "homeScore": 2,
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "BEST台中一中",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 5,
            "group": "A",
            "time": "1899-12-30T04:23:18.000Z",
            "homeTeam": "足夢 U18B",
            "homePK": 0,
            "homeScore": 2,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "FOCUS",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 6,
            "group": "A",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "台中一中白",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "明道中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 7,
            "group": "B",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "嶺東中學",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "台中一中黑",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-12T16:00:00.000Z",
            "gameNumber": 8,
            "group": "B",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "足夢 U18A",
            "homePK": 0,
            "homeScore": 5,
            "awayScore": 1,
            "awayPK": 0,
            "awayTeam": "BEST台中一中",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 9,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "C1",
            "homePK": 0,
            "homeScore": 10,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "台中一中白",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 10,
            "group": "A",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "足夢 U18B",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 1,
            "awayPK": 0,
            "awayTeam": "明道中學",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 11,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "BEST台中一中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 3,
            "awayPK": 0,
            "awayTeam": "嶺東中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 12,
            "group": "B",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "足夢 U18A",
            "homePK": 0,
            "homeScore": 5,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "台中一中黑",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 13,
            "group": "SF",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "FOCUS",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 5,
            "awayPK": 0,
            "awayTeam": "嶺東中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-13T16:00:00.000Z",
            "gameNumber": 14,
            "group": "SF",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "足夢 U18B",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "足夢 U18A",
            "venue": "崇倫 B"
        },
        {
            "date": "2024-04-20T16:00:00.000Z",
            "gameNumber": 15,
            "group": "3rd",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "FOCUS",
            "homePK": 0,
            "homeScore": 3,
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "足夢 U18B",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-20T16:00:00.000Z",
            "gameNumber": 16,
            "group": "F",
            "time": "1899-12-30T03:23:18.000Z",
            "homeTeam": "嶺東中學",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 3,
            "awayPK": 0,
            "awayTeam": "足夢 U18A",
            "venue": "崇倫 A"
        }
    ],
    "/mayors-cup/2025/school": [
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 1,
            "group": "A",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "安和國中",
            "homePK": 0,
            "homeScore": 7,
            "awayScore": "",
            "awayPK": 0,
            "awayTeam": "衛道中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 2,
            "group": "A",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "爽文國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "崇倫國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 3,
            "group": "B",
            "time": "1899-12-30T03:23:18.000Z",
            "homeTeam": "黎明國中",
            "homePK": 0,
            "homeScore": 3,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "潭秀國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 4,
            "group": "A",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "爽文國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "安和國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 5,
            "group": "A",
            "time": "1899-12-30T07:23:18.000Z",
            "homeTeam": "崇倫國中",
            "homePK": 0,
            "homeScore": 6,
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "衛道中學",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-21T16:00:00.000Z",
            "gameNumber": 6,
            "group": "B",
            "time": "1899-12-30T08:23:18.000Z",
            "homeTeam": "福科國中",
            "homePK": 0,
            "homeScore": 8,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "黎明國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 7,
            "group": "A",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "崇倫國中",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 2,
            "awayPK": 0,
            "awayTeam": "安和國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 8,
            "group": "A",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "衛道中學",
            "homePK": 0,
            "homeScore": "",
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "爽文國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 9,
            "group": "B",
            "time": "1899-12-30T03:23:18.000Z",
            "homeTeam": "潭秀國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 5,
            "awayPK": 0,
            "awayTeam": "福科國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 10,
            "group": "SF",
            "time": "1899-12-30T06:23:18.000Z",
            "homeTeam": "安和國中",
            "homePK": 0,
            "homeScore": 2,
            "awayScore": 5,
            "awayPK": 0,
            "awayTeam": "潭秀國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-22T16:00:00.000Z",
            "gameNumber": 11,
            "group": "3rd",
            "time": "1899-12-30T07:23:18.000Z",
            "homeTeam": "崇倫國中",
            "homePK": 0,
            "homeScore": 3,
            "awayScore": 6,
            "awayPK": 0,
            "awayTeam": "福科國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-29T16:00:00.000Z",
            "gameNumber": 12,
            "group": "F",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "安和國中",
            "homePK": 0,
            "homeScore": 5,
            "awayScore": 1,
            "awayPK": 0,
            "awayTeam": "崇倫國中",
            "venue": "崇倫 A"
        },
        {
            "date": "2024-04-29T16:00:00.000Z",
            "gameNumber": 13,
            "group": "",
            "time": "1899-12-30T02:23:18.000Z",
            "homeTeam": "潭秀國中",
            "homePK": 0,
            "homeScore": 1,
            "awayScore": 4,
            "awayPK": 0,
            "awayTeam": "福科國中",
            "venue": "崇倫 A"
        }
    ]
};

export function getSsgPageData(path: string): SsgMatch[] {
    // WHY 正規化尾斜線：Cloudflare Pages 以 /foo/ 形式服務（乾淨網址 308 過來），
    // 而預渲染時的 key 是無尾斜線的 /foo。不正規化會讓訪客在 hydration 後
    // 讀不到烘入資料、把預渲染好的內容清空（staging 實測）。
    const key = path.replace(/\/+$/, '') || '/';
    return ssgPages[key] ?? [];
}
